import api from '@/api';
import BackupSearchRequest from '@/model/backup/BackupSearchRequest';

// Backup restore module (permission BACKUP_RESTORE): browse the old server's
// data (since 16 Sep 2026), compare it with the current system and restore
// selected records. The backup source itself is read-only on the server side.
const pageResult = response => ({
  data: response.data.data || [],
  pagination: {
    page: response.data.metadata.page,
    total: response.data.metadata.total,
  },
  sort: response.data.metadata.sort || {},
});

const list = (url) => (actions, { filter, pagination, sort }) => api.base()
  .post(url, BackupSearchRequest({ ...(filter || {}), pagination, sort }))
  .then(pageResult);

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // { source:{host,crmDatabase,coreDatabase}, since, reachable, counts:{clients,monetary,trades,notes,accounts} }
    getBackupInfo() {
      return api.base()
        .get('/backup/info')
        .then(response => response.data.data);
    },
    getAllBackupClients: list('/backup/clients/get/all'),
    getAllBackupMonetary: list('/backup/monetary/get/all'),
    getAllBackupTrades: list('/backup/trades/get/all'),
    getAllBackupNotes: list('/backup/notes/get/all'),
    getAllBackupRestoreLog: list('/backup/restore/log/get/all'),
    // { client, diffs, accounts, monetary, trades, notes }
    getBackupClient(actions, backupId) {
      return api.base()
        .get('/backup/clients/' + encodeURIComponent(backupId))
        .then(response => response.data.data);
    },
    // request: { clientBackupId, restoreClient, accounts[], fields[], monetary[{backupId,applyToBalance}], trades[], notes[] }
    // → { clientId, items:[{kind, backupId, result, currentId, message}] }
    restoreBackup(actions, request) {
      return api.base()
        .post('/backup/restore', request)
        .then(response => response.data.data);
    },
  },
};
